<template>
  <header class="header">
    <button class="menu-toggle" @click="toggleMenu">
      <menu-toggle class="icon"
        preserveAspectRatio="none"
        v-if="!open" />
      <close-icon class="icon"
        v-if="open" />
    </button>
    <h1 class="logo"><a href="#home"><img src="../../assets/logo.png" alt="Zespri"/></a></h1>
  </header>
</template>

<script>
import MenuToggle from '../../assets/icons/hamburger.svg?inline'
import CloseIcon from '../../assets/icons/modal-close.svg?inline'

export default{
  name: 'navigation-header',
  components: {
    'menu-toggle': MenuToggle,
    'close-icon': CloseIcon
  },
  props: {
    open: Boolean
  },
  methods: {
    toggleMenu() {
      this.$emit('toggle-menu', this.open)
    }
  }
}
</script>

<style lang="scss">
/** navigation header (unscoped) **/
@import '../../theme';

// Only add a background color to the logo when the menu is closed.
// This allows the logo to extend outside of the mobile header background.
#menu:not(.open) .logo {
  background-color: zespri-brand-color(yellow);

  @include media-breakpoint-up(lg) {
    background-color: transparent;
  }
}

// Open state mobile styling.
#menu.open {
  // Hide the logo on mobile.
  .logo {
    opacity: 0;
  }

  // Make sure the logo is always visible on desktop.
  @include media-breakpoint-up(lg) {
    .logo {
      opacity: 1;
    }
  }
}
</style>

<style scoped lang="scss">
/** navigation header **/
@import '../../theme';
@import './variables';

$menu-toggle-width: 42px;
$menu-toggle-height: 36px;
$menu-toggle-margin: 10px;

.header {
  box-sizing: border-box;
  width: 100%;
  height: $header-h;
  max-height: $header-h;
  padding: 10px;
  flex-grow: 1;

  @include media-breakpoint-up(lg) {
    max-height: none;
    flex-grow: 0;
  }
}

.menu-toggle {
  @include flex-centered;
  align-self: center;
  height: $menu-toggle-height;
  width: $menu-toggle-width;
  padding: 0;
  border: none;

  cursor: pointer;
  font-size: $f-m;
  background-color: transparent;

  transition: background-color $t-s linear;

  @include media-breakpoint-up(lg) {
    display: none;
  }
}

.icon {
  width: 25px;
  height: 16px;
  fill: currentColor;
  stroke: currentColor;
  stroke-width: 2px;
  stroke-linecap: round;
}

.logo {
  @include absolute-top-center;
  border-radius: 50%;
  padding: $logo-pad;
  margin: 0 auto;
  width: $logo-s + $logo-pad;
  height: $logo-s + $logo-pad;
  z-index: zespri-layer(header-content);
  opacity: 1;
  transition: opacity $t-s linear;

  font-size: $f-m;

  img {
    max-width: $logo-s;
    max-height: $logo-s;
  }

  @include media-breakpoint-up(lg) {
    width: $logo-l + $logo-pad;
    height: $logo-l + $logo-pad;

    img {
      max-width: $logo-l;
      max-height: $logo-l;
    }
  }
}

</style>
